import ColorPicker from '../Custom/ColorPicker';
import Box from '../UI/Box';
import TextInput from '../Unistyles/TextInput';

type ChatInfoInputsProps = {
  title: string;
  titlePlaceholder?: string;
  titleMaxLength?: number;
  onChangeTitle(next: string): void;
  color: string | null;
  onChangeColor(next: string): void;
};

export default function ChatInfoInputs({
  title,
  titlePlaceholder = 'Title',
  titleMaxLength = 20,
  onChangeTitle,
  onChangeColor,
}: ChatInfoInputsProps) {
  return (
    <Box space="md" p="lg">
      <TextInput
        autoCapitalize="words"
        enterKeyHint="done"
        maxLength={titleMaxLength}
        testID="ChatInfoTitleInput"
        value={title}
        placeholder={titlePlaceholder}
        onChangeText={onChangeTitle}
      />

      <ColorPicker onPress={onChangeColor} />
    </Box>
  );
}
